import axios from 'axios';
import { Cart, CartService } from "@firenet-designs/shopify-common";
import { difInMiliSeconds } from '../../../shared/helpers/DateHelpers';
import DiscountPresenter from "../presenters/DiscountPresenter";

export default class DiscountService {
  // Logic at this point means we are supposed to be applying Discounts, etc.

  constructor(settings) {

    this.settings = settings;
    this.couponCode = settings.couponCode;
    this.discountKey = settings.discountKey;
    this.discountType = settings.discountType;
    this.delimiter = settings.delimiter;
    this.discountLength = settings.discountLength;
    this.isVariantOnly = settings.isVariantOnly;
    this.variantOnlyId = settings.variantOnlyId;

    const discountProduct = localStorage.getItem(this.discountKey);
    const [ handle, discountAmount, timestampStarted ] = discountProduct.split(this.delimiter);
    this.handle = handle;
    this.discountAmount = discountAmount;
    this.discount = this.discountType === 'flat' ? discountAmount : (100 - discountAmount) / 100;
    this.timestampStarted = parseInt(timestampStarted, 10);


    this.cartService = new CartService('shopify');
    this.discountPresenter = new DiscountPresenter(this.settings, this.handle, this.discount);


    this.init();
  }

  async init() {
    await this.discountPresenter.init();

    FND.common.eventEmitter.on('sale_is_over', () => {
      this.clearSale();
    });


    if(difInMiliSeconds(this.timestampStarted, Date.now()) > this.discountLength) {
      this.clearSale();
      return;
    }

    this.discountPresenter.initializeBanner(this.timestampStarted, this.discountLength);

  }

  clearSale() {
    localStorage.setItem(this.discountKey, 'false'); // Remove it
    this.cartService.updateAttributes({
      [this.discountKey]: 'false'
    });
  }

  calculateDiscountCartSubtotal(cart) {
    return cart.items.reduce((currentSubtotal, currentLineItem) => {
      if(currentLineItem.handle === this.handle) {
        if(this.isVariantOnly) {
          if(this.variantOnlyId === currentLineItem.id){
            if(this.discountType === 'flat'){
              return currentSubtotal + (currentLineItem.quantity * this.discount);
            }
            return currentSubtotal + (currentLineItem.quantity * currentLineItem.price * this.discount);
          }
        }
        else {
          if(this.discountType === 'flat'){
            return currentSubtotal + (currentLineItem.quantity * this.discount);
          }
          return currentSubtotal + (currentLineItem.quantity * currentLineItem.price * this.discount);
        }
      }
      return currentSubtotal + (currentLineItem.quantity * currentLineItem.price);
    }, 0)
  }

  buildCartAttribute() {
    return this.handle+this.delimiter+this.discountAmount+this.delimiter+this.timestampStarted+this.delimiter+this.discountType+this.delimiter+this.variantOnlyId;
  }
}